import isAndroid from '../lib/isAndroid.js';
import isYahoo from '../lib/isYahoo.js';
import getAndVer from '../lib/getAndVer.js';

const importAjaxZip3 = () => {
	const promise = new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = 'https://ajaxzip3.github.io/ajaxzip3.js';
		document.body.appendChild(script);
		script.onload = () => {
			resolve();
		}
		script.onerror = () => {
			reject('cannnot load script');
		}
	});
}

// function attend() {
// 	var session_ninzu = $('select[name="session_ninzu"]').find(":selected").val();
// 	if (session_ninzu === '') {
// 		session_ninzu = 0;
// 	}
// 	// 付添の方の属性のセレクタの表示
// 	for (var i = 1; i < session_ninzu; i++) {
// 		$('.js-attend' + i).show()
// 			.find("input,select,textarea")
// 			.prop("disabled", false);
// 	}
// 	// 付添の方の属性のセレクタの非表示
// 	for (var i = session_ninzu; i < 6; i++) {
// 		$('.js-attend' + i).hide()
// 			.find("input,select,textarea")
// 			.prop("disabled", true);
// 	}
// 	// 参加人数が2以上なら付添の方を表示、1であれば非表示
// 	if (session_ninzu > 1) {
// 		$('.js-attend-title').show();
// 		ACMS.Dispatch.validator(document);
// 	} else {
// 		$('.js-attend-title').hide();
// 	}
// }

export default function () {
	// var debug_mode = 0;
	//debug_modeが1だと未入力の項目があっても次に進めます。
	$(async function () {
		if (isAndroid() && getAndVer() < 5) {
			$('.js-is-not-android').remove();
		} else {
			$('.js-is-android').remove();
		}
		$("[name='opencampus']:radio:checked").change();
		var toggleSection = function () {
			$(".js-toggling-section")
				.find("input[type=hidden]")
				.filter(function () {
					return $(this).attr("name").indexOf("require") !== -1
				})
				.prop("disabled", true);
			$(".js-toggling-section")
				.find(".contactLabel")
				.addClass("contactLabelArbitrary")
				.removeClass("contactLabelRequired")
				.html("任意");
			var $selector = $($(".js-course-selector:checked").data("toggling-section"));
			$selector
				.find("input[type=hidden]")
				.prop("disabled", false);
			$selector
				.find(".contactLabel")
				.addClass("contactLabelRequired")
				.removeClass("contactLabelArbitrary")
				.html("必須");
		}
		// var checkField = function () {
		// 	$(".js-course-item:visible")
		// 		.find("input:visible:not([type='checkbox'],[type='radio']),select")
		// 		.each(function () {
		// 			var $ele = $(this);
		// 			var name = $(this).attr("name");
		// 			if ($ele.val()) {
		// 				var email = name + ":v#email";
		// 				var $ev = $ele.parents(".js-course-item").find("[name='" + email + "']");
		// 				if ($ev.length > 0) {
		// 					if (!$ele.val().match(/^(?:[^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff]+(?![^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff])|"[^\\\\\x80-\xff\n\015"]*(?:\\\\[^\x80-\xff][^\\\\\x80-\xff\n\015"]*)*")(?:\.(?:[^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff]+(?![^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff])|"[^\\\\\x80-\xff\n\015"]*(?:\\\\[^\x80-\xff][^\\\\\x80-\xff\n\015"]*)*"))*@(?:[^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff]+(?![^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff])|\[(?:[^\\\\\x80-\xff\n\015\[\]]|\\\\[^\x80-\xff])*\])(?:\.(?:[^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff]+(?![^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff])|\[(?:[^\\\\\x80-\xff\n\015\[\]]|\\\\[^\x80-\xff])*\]))*$/)) {
		// 						// $ele.siblings(".fa-check").remove();
		// 						$ele.removeClass("js-success");
		// 						return;
		// 					}
		// 				}
		// 				if ($ele.hasClass("js-furigana")) {
		// 					if (!$ele.val().match(/^[ァ-ン| |　]+$/)) {
		// 						// $ele.siblings(".fa-check").remove();
		// 						$ele.removeClass("js-success");
		// 						return;
		// 					}
		// 				}
		// 				// if (!$ele.next().is(".fa-check")) {
		// 				// 	var $fa = $("<i class='fa fa-check'></i>");
		// 				// 	$ele.after($fa);
		// 				// 	setTimeout(function () {
		// 				// 		$ele.siblings(".fa-check").addClass('js-show-checkbox');
		// 				// 	});
		// 				// }
		// 				$ele.addClass("js-success");
		// 			} else {
		// 				$ele.next().removeClass("js-show-checkbox");
		// 				// setTimeout(function () {
		// 				// 	$ele.siblings(".fa-check").remove();
		// 				// }, 300)
		// 				$ele.removeClass("js-success");
		// 			}
		// 		});
		// }
		// var getRemainingRequiredField = function () {
		// 	return $(".js-course-item:visible")
		// 		.find("input[type=hidden]:enabled")
		// 		.filter(function () {
		// 			var name = $(this).attr("name")
		// 			if (name.indexOf("required") == -1) {
		// 				return false;
		// 			}
		// 			name = name.replace(":v#required", "");
		// 			var $ele = $(this).parents(".js-course-item").find("[name='" + name + "']");
		// 			if ($ele.length == 0) {
		// 				$ele = $(this).parents(".js-course-item").find("[name='" + name + "[]']");
		// 			}
		// 			if ($ele.attr("type") == "checkbox" || $ele.attr("type") == "radio") {
		// 				if ($("[name='" + name + "']:checked").length > 0 || $("[name='" + name + "[]']:checked").length > 0) {
		// 					return false;
		// 				} else {
		// 					return true;
		// 				}
		// 			}
		// 			if ($ele.val()) {
		// 				var email = name + ":v#email";
		// 				var $ev = $(this).parents(".js-course-item").find("[name='" + email + "']");
		// 				if ($ev.length > 0) {
		// 					if (!$ele.val().match(/^(?:[^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff]+(?![^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff])|"[^\\\\\x80-\xff\n\015"]*(?:\\\\[^\x80-\xff][^\\\\\x80-\xff\n\015"]*)*")(?:\.(?:[^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff]+(?![^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff])|"[^\\\\\x80-\xff\n\015"]*(?:\\\\[^\x80-\xff][^\\\\\x80-\xff\n\015"]*)*"))*@(?:[^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff]+(?![^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff])|\[(?:[^\\\\\x80-\xff\n\015\[\]]|\\\\[^\x80-\xff])*\])(?:\.(?:[^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff]+(?![^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff])|\[(?:[^\\\\\x80-\xff\n\015\[\]]|\\\\[^\x80-\xff])*\]))*$/)) {
		// 						return true;
		// 					}
		// 				}
		// 				if ($ele.hasClass("js-furigana")) {
		// 					if (!$ele.val().match(/^[ァ-ン| |　]+$/)) {
		// 						// $ele.siblings(".fa-check").remove();
		// 						$ele.removeClass("js-success");
		// 						return true;
		// 					}
		// 				}
		// 				return false;
		// 			} else {
		// 				return true;
		// 			}
		// 		}).length;
		// };

		// 参加人数を変更したら付添の方のセレクタを操作する
		// $(".js-session-ninzu-selector").change(function () {
		// 	attend();
		// });

		$(".js-course-item").hide();
		const selector = "#basic,#session,#opencampus,#consent,#conference,#oc";
		$(selector).show();

		$(document).on("input change click", ".js-form input,.js-form select,.js-form textarea", function () {
			if ($(".js-not-apply input:checked").length) {
				$(".js-population").hide();
				$(".js-bus").hide();
				$("#js-toeic").hide();
			} else if ($(".js-session input:checked").length) {
				$(".js-population").show();
				$(".js-bus").show();
				$("#js-toeic").show();
			}

			if ($("[name='require_material']:checked").length || $("#input-content-brochure:checked").length) {
				$("#address,#brochure")
					.show()
					.find("input,select,textarea")
					.prop("disabled", false);
			} else {
				$("#address,#brochure")
					.hide()
					.find("input,select,textarea")
					.prop("disabled", true);
			}


			toggleSection();

			$(".js-switch-section:hidden")
				.find("input,select,textarea")
				.prop("disabled", true);

			if ($(".js-switch-section").find(".contactLabelArbitrary").length == 0) {
				$(".js-switch-section:visible")
					.find("input,select,textarea")
					.prop("disabled", false);
			}

			//セレクターのstyling
			$(".contactNotSelected").each(function () {
				var $parent = $(this).parent("select");
				var parentVal = $parent.val();
				var val = $(this).val();
				if (parentVal == val) {
					$parent.css("color", "#C3C3C3");
				} else {
					$parent.css("color", "#333333");
				}
			});

			// var number = getRemainingRequiredField();
			// checkField();
			// $(".js-number").html(number);
			// if (number == 0) {
			// 	$(".js-contact-box").addClass("js-contact-box-hidden");
			// 	$(".js-submit-btn").val("確認");
			// 	$(".js-submit-btn").removeClass("js-submit-btn-disabled");
			// 	// $(".contactConfirmBtn").prop("disabled",false);
			// } else {
			// 	$(".js-contact-box").removeClass("js-contact-box-hidden");
			// 	$(".js-submit-btn").val("未入力の必須項目があります");
			// 	$(".js-submit-btn").addClass("js-submit-btn-disabled");
			// 	// $(".contactConfirmBtn").prop("disabled",true);
			// }
		})

		$(".js-form input").change();

		// $(".js-form").submit(function (e) {
		// 	var number = getRemainingRequiredField();
		// 	if (number && debug_mode === 0) {
		// 		e.preventDefault();
		// 		alert("未入力の必須項目が" + number + "個あります。");
		// 	}
		// 	$(window).off("beforeunload");
		// });
		// $(window).bind("beforeunload", function () {
		// 	return "ページから移動すると、入力したデータは保存されません。";
		// });
		// if (!location.hash) {
		// 	location.hash = "#content=brochure";
		// }
		// var data = location.hash.replace("#content=", "");
		// $(".js-course-selector").each(function () {
		// 	if ($(this).val() == data) {
		// 		$(this).prop("checked", true);
		// 	}
		// });
		// $(".js-course-selector").click(function () {
		// 	location.hash = "content=" + $(this).val();
		// });

		//未入力の項目に移動するための処理
		$(".js-direction").click(function () {
			var offset = -80;
			var $items = $(".js-course-item:visible")
				.find("input[type=hidden]:enabled");
			var flag = false;
			$items.each(function () {
				if (flag) {
					return;
				}
				var name = $(this).attr("name")
				if (name.indexOf("required") == -1) {
					return;
				}
				name = name.replace(":v#required", "");
				var $ele = $(this).parents(".js-course-item").find("[name='" + name + "']");
				if ($ele.length == 0) {
					$ele = $(this).parents(".js-course-item").find("[name='" + name + "[]']");
				}
				if ($ele.attr("type") == "checkbox" || $ele.attr("type") == "radio") {
					if ($("[name='" + name + "']:checked").length != 0 || $("[name='" + name + "[]']:checked").length != 0) {
						return;
					}
				}
				if ($ele.attr("type") != "checkbox" && $ele.attr("type") != "radio") {
					if ($ele.val()) {
						if ($ele.attr("type") == "email") {
							if ($ele.val().match(/^(?:[^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff]+(?![^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff])|"[^\\\\\x80-\xff\n\015"]*(?:\\\\[^\x80-\xff][^\\\\\x80-\xff\n\015"]*)*")(?:\.(?:[^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff]+(?![^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff])|"[^\\\\\x80-\xff\n\015"]*(?:\\\\[^\x80-\xff][^\\\\\x80-\xff\n\015"]*)*"))*@(?:[^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff]+(?![^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff])|\[(?:[^\\\\\x80-\xff\n\015\[\]]|\\\\[^\x80-\xff])*\])(?:\.(?:[^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff]+(?![^(\040)<>@,;:".\\\\\[\]\000-\037\x80-\xff])|\[(?:[^\\\\\x80-\xff\n\015\[\]]|\\\\[^\x80-\xff])*\]))*$/)) {
								return;
							}
						} else {
							return;
						}
					}
				}
				flag = true;
				var top = $ele.offset().top + offset;
				$("html,body").animate({ scrollTop: top });
			});
		});

		$(".js-contact-box").autoStick({
			wrapperElement: ".js-contact-wrap",
			beforeElement: ".js-contact-mark",
			marginRight: 0.1,
			scrollMargin: 60,
			fixTop: 60
		});
		$('#js-school_search').bind('click', function (e) {
			var win = window.open('/net/school-popup.html', 'popup', 'width=680, height=600, status=no, scrollbars=yes');
			if (typeof win.addEventListener === "undefined") {
				win.attachEvent("onunload", function () {
					$(".js-course-selector:checked").change();
				})
			} else {
				win.addEventListener("unload", function () {
					$(".js-course-selector:checked").change();
				});
			}
			return false;
		});
		$('[name="session"]:radio').change(function () {
			if ($(this).parent().hasClass('js-session-option')) {
					$('.js-population').show()
						.find("input,select,textarea")
						.prop("disabled", false);
						if(typeof ACMS.Dispatch.validator == 'function'){
							ACMS.Dispatch.validator($('.js-population').get(0));
						}
				} else {
					$('.js-population').hide()
						.find("input,select,textarea")
						.prop("disabled", true);
				}
			}).change();
		$('[name="conference"]:radio').change(function () {
			if ($(this).parent().hasClass("js-conference")) {
				$('.js-conference-time').show()
					.find("input,select,textarea")
					.prop("disabled", false);
					if(typeof ACMS.Dispatch.validator == 'function'){
						ACMS.Dispatch.validator($('.js-conference-time').get(0));
					}
			} else {
				$('.js-conference-time').hide()
					.find("input,select,textarea")
					.prop("disabled", true);
			}
		}).change();
		$('select[name="session_ninzu"]').change(function () {
			var session_ninzu = $('select[name="session_ninzu"]').find(":selected").val();
			// 参加人数が2以上なら付添の方を表示、1であれば非表示
			if (session_ninzu > 1) {
				$('.js-attend-title').show();
			} else {
				$('.js-attend-title').hide();
			}
			// 付添の方の属性のセレクタの表示
			for (var i = 1; i < session_ninzu; i++) {
				$('select[name="attend' + i + '"]').show();
			}
			// 付添の方の属性のセレクタの非表示にする
			for (var i = session_ninzu; i < 6; i++) {
				$('select[name="attend' + i + '"]').hide().val('');
			}
		});
		// $('[name="session"]:radio:checked').change();
		// $('[name="conference"]:radio:checked').change();
		await importAjaxZip3();
		$('#zipCode1').keyup(function () {
			AjaxZip3.zip2addr('customer_zip_code', '', 'customer_province', 'customer_address1');
		});
	});

	//URLに応じてフォームにチェックをつける
	$(function () {
		$(".js-contact-box").autoStick({
			wrapperElement: ".js-contact-wrap",
			beforeElement: ".js-contact-mark",
			marginRight: 0.1,
			scrollMargin: 60,
			fixTop: 60
		});
		// 説明会のラジオボタンにチェックがある場合にはご参加人数を表示（初回読み込み時、リアプライ時）
		if ($('input[name="session"]:checked').length == 0 || $('input[name="session"]:checked').val() == '説明会を申し込まない') {
			$('.js-population').hide()
			.find("input,select,textarea")
			.prop("disabled", true);
		} else {
			$('.js-population').show()
			.find("input,select,textarea")
			.prop("disabled", false);
			//ACMS.Dispatch.validator($('.js-population').get(0));
		}
		// 個別相談のラジオボタンにチェックがある場合には希望日時を表示（初回読み込み時、リアプライ時）
		if ($('input[name="conference"]:checked').length == 0 || $('input[name="conference"]:checked').val() == '個別相談を申し込まない') {
			$('.js-conference-time').hide()
				.find("input,select,textarea")
				.prop("disabled", true);
		} else {
			$('.js-conference-time').show()
				.find("input,select,textarea")
				.prop("disabled", false);
			//ACMS.Dispatch.validator($('.js-conference-time').get(0));
		}
		// attend();
	});
}
